import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setPage, setMaxPages, setSorting, setCheckedItem, toggleAddModal, toggleEditModal } from '../../store/trainingsTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
  sortButtonsConfig,
} from './trainingsTableConfig.js';
import { fetchTrainings } from './trainingsTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UnisersalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';

import './Trainings.css';

function Trainings() {

  const dispatch = useDispatch(); 
  const activeTab = useSelector((state) => state.trainings.activeUsersTab);
  const totalPages = useSelector((state) => state.trainings.maxPages);
  const currentPage = useSelector((state) => state.trainings.currentPage);
  const sortBy = useSelector((state) => state.trainings.sortBy);
  const sortDirection = useSelector((state) => state.trainings.sortDirection);
  const checkedItems = useSelector((state) => state.trainings.checkedItems);
  const keyword = useSelector((state) => state.trainings.keyword);
  const searchValue = useSelector((state) => state.trainings.searchValue);

  const needRefresh = useSelector((state) => state.trainings.needRefresh);

  const [rows, setRows] = useState([]);
  const sortArrowColorActive = '#FFFFFF';
  const sortArrowColorInactive = 'rgba(255,255,255,0.45)';

    // Funkcja otwierająca modal (Redux Action)
    const handleToggleAddModal = () => {
      dispatch(toggleAddModal());
    };
    const handleToggleEditModal = () => {
      dispatch(toggleEditModal());
    };

  useEffect(() => {
    fetchTrainings(sortBy, sortDirection, keyword, currentPage, dispatch, setMaxPages, setRows, checkedItems);

  }, [currentPage, sortBy, sortDirection, checkedItems, needRefresh, keyword]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rows,
    checkedItems);

    const paginationProps = {
      reduxSelector: (state) => state.trainings.currentPage,
      reduxAction: setPage,
      totalPages: totalPages,
      maxVisibleButtons: 5,
    };
    
    const rightSideConfig2 = [
      {
        component: Pagination, // Komponent do wyrenderowania
        props: paginationProps, // Właściwości przekazywane do komponentu
      },
    ];

  return (
    <div>
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeTab, dispatch)} buttons={empty} />
      
        <div className="table-container">          
            <UnisersalLineWithComponents leftSide={empty} rightSide={rightSideConfig(searchValue, dispatch)} />
            <Table
              headers={headers}
              rowsClass='row-sports'
              cellClass='cell-sports'
              rows={rows}
              columnWidths={headerWidths}
              idViewing={true}
              idArrayId={1}
              cellClass2='cell-center'
              cellClass2ConditionList={[1, 4, 5, 6]} />
            <UnisersalLineWithComponents leftSide={empty} rightSide={rightSideConfig2} />
        </div>
      </Content>
    </div>
  );
}

export default Trainings;